import React from 'react';
import projectImage from '../img/P5.png';
import Navbar from './Navbar';
import { motion } from "framer-motion";
import { FaGithub } from "react-icons/fa";
import { Link } from "react-router-dom";

const Proj2 = () => {
  return (
    <div>
      <Navbar />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
        id='about'
        className="mx-auto px-4 md:px-20"
      >
        <h2 className="text-4xl sm:text-4xl font-bold pl-6 pt-20">Project Title: KA Management</h2>

        <div className="max-w-screen-lg mx-auto grid grid-cols-1 md:grid-cols-2 gap-4 items-center justify-center h-full py-10">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.5 }}
            className="h-75 w-75 "
          >
            <img
              src={projectImage}
              alt="Project Screenshot"
              className="mx-auto w-full shadow-2xl"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.5 }}
            className="flex flex-col justify-center h-full  ml-4 "
          >
            <h2 className="text-3xl sm:text-4xl font-bold">Key tools and technologies:</h2>
            <ul className="flex flex-wrap justify-center pb-5 text-xl sm:text-2xl font-bold pt-2">
              <li className="pl-4">HTML5</li>
              <li className="pl-4">CSS3</li>
              <li className="pl-4">React JS</li>
              <li className="pl-4">Bootstrap</li>
              <li className="pl-4">Express JS</li>
            </ul>

            <ul className="flex justify-center pb-5 text-xl sm:text-2xl font-bold">
              <li className="pl-4">
                <Link to="https://github.com/45aman/KA"><FaGithub size="3.3rem" /></Link>
              </li>
            </ul>
          </motion.div>
        </div>

        <h1 className="text-4xl sm:text-3xl font-bold pt-10 pl-4">Project Description:</h1>
        <div className="px-4 md:px-20">
          <p className="py-4">
            Introducing my personal project, an advanced Automobile Franchise Management System tailored to meet the specific needs of our automobile franchise. With a keen focus on centralizing customer and supplier data, this system aims to streamline operations and enhance efficiency.

<br/>At the core of the system is a comprehensive supplier database, encompassing vital information and discount percentages for each brand they supply. This enables us to easily identify and shortlist suppliers offering the maximum discounts on specific brands, facilitating optimized order placements.

<br/>In addition to supplier management, the system also features a user-friendly billing section. It includes two distinct billing options: one with GST calculation for simplified return calculations and another without GST for specific requirements. This billing functionality ensures smooth financial management and accurate documentation.

<br/>Moreover, we prioritize maintaining crucial retailer account data to foster better communication and collaboration with our retailers. This feature enhances the overall customer experience and strengthens our business relationships.

<br/>Leveraging the power of modern technology, the project adopts the MERN (MongoDB, Express.js, React, and Node.js) stack. The robust front-end, already developed, ensures an intuitive user interface, while the ongoing work on the back-end ensures seamless data processing and storage.

<br/>Inspired by college retail management projects, this personal project is meticulously crafted to suit the unique demands of our automobile franchise. By embracing new technologies and innovative solutions, we envision a more efficient and organized approach to handling customer and supplier information.

<br/>As the project nears completion, we anticipate a significant improvement in data management and decision-making, empowering my dad to make well-informed choices and drive growth for our automobile franchise. With the potential to revolutionize our operations, this project marks a remarkable step towards business optimization and success.
          </p>

          {/* <div>
            <button
              type="button"
              className="text-white bg-gradient-to-r from-cyan-400 via-cyan-500 to-cyan-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"
            >
              Video Link
            </button>
          </div> */}
        </div>
      </motion.div>
    </div>
  );
};

export default Proj2;
